import { render, staticRenderFns } from "./ZhanhuiSshyStatTableBlock.vue?vue&type=template&id=8bbfda84&scoped=true"
import script from "./ZhanhuiSshyStatTableBlock.vue?vue&type=script&lang=js"
export * from "./ZhanhuiSshyStatTableBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhanhuiSshyStatTableBlock.vue?vue&type=style&index=0&id=8bbfda84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbfda84",
  null
  
)

export default component.exports